import { Box, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import BaseYearMessage from '@Router/EsgGreenhouse/Components/BaseYearMessage';
import GasEmissionMessage from '@Router/EsgGreenhouse/Components/GasEmissionMessage';
import dayjs from 'dayjs';
import OtherGreenhouseActions from './OtherGreenhouseActions';

enum OTHER_GH_TABLE_COLUMN {
  ID = 'id',
  SCOPE = 'scope',
  BASE_YEAR = 'baseYear',
  NEAR_TERM = 'nearTermTarget',
  LONG_TERM = 'longTermTarget',
}

export const OTHER_GH_VISIBILITY = {
  [OTHER_GH_TABLE_COLUMN.ID]: false,
};

export const OTHER_GREENHOUSE_COLUMNS: GridColDef[] = [
  { field: OTHER_GH_TABLE_COLUMN.ID, headerName: 'No.' },
  {
    field: OTHER_GH_TABLE_COLUMN.SCOPE,
    headerName: 'ขอบเขตการปล่อยก๊าซเรือนกระจก',
    minWidth: 140,
    renderCell: ({ value }) => {
      const { nameTh, nameEn } = value;
      return (
        <Box>
          <Typography>{nameTh}</Typography>
          <Typography mt={2}>{nameEn}</Typography>
        </Box>
      );
    },
  },
  {
    field: OTHER_GH_TABLE_COLUMN.BASE_YEAR,
    headerName: 'ปีฐาน',
    minWidth: 200,
    flex: 1,
    renderCell: ({ value }) => {
      const { year, gasEmissionQuantity } = value || {};

      return (
        <BaseYearMessage
          year={year}
          gasEmissionQuantity={gasEmissionQuantity}
        />
      );
    },
  },
  {
    field: OTHER_GH_TABLE_COLUMN.NEAR_TERM,
    headerName: 'ปีเป้าหมายระยะสั้น',
    minWidth: 200,
    flex: 1,
    renderCell: ({ value }) => {
      const { year, gasEmissionPercent, gasEmissionQuantity } = value;
      const baseYear = year ? dayjs(year).get('year') : undefined;
      return (
        <GasEmissionMessage
          year={baseYear}
          percent={gasEmissionPercent}
          quantity={gasEmissionQuantity}
        />
      );
    },
  },
  {
    field: OTHER_GH_TABLE_COLUMN.LONG_TERM,
    headerName: 'ปีเป้าหมายระยะยาว',
    minWidth: 200,
    flex: 1,
    renderCell: ({ value }) => {
      const { year, gasEmissionPercent, gasEmissionQuantity } = value;
      const baseYear = year ? dayjs(year).get('year') : undefined;
      return (
        <GasEmissionMessage
          year={baseYear}
          percent={gasEmissionPercent}
          quantity={gasEmissionQuantity}
        />
      );
    },
  },
  {
    field: 'action',
    headerName: 'แก้ไข/ลบ',
    headerAlign: 'left',
    type: 'actions',
    minWidth: 80,
    getActions: (field) => {
      const { id } = field;
      return [<OtherGreenhouseActions rowId={id} />];
    },
  },
];
